import { render, staticRenderFns } from "./Contatto-side.vue?vue&type=template&id=4c423800"
import script from "./Contatto-side.vue?vue&type=script&lang=js"
export * from "./Contatto-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports